import React from "react";
export const WASidenavNav: React.FC<{}> = props => (
  <nav className="sidenav">{props.children}</nav>
);
